import { useState } from "react";
import { Phone } from "lucide-react";
import { api, errorMessage } from "../lib/api";
import { whenCallReturns } from "../lib/callReturn";

export const CallConfirmForm = ({ venue, action, csrfToken, onBack, onStarted, onReturned }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const confirm = async () => {
    setBusy(true); setError("");
    try {
      const { data } = await api.post(`/venues/${venue.id}/calls/start`,
        { contact_value: action.value, channel: action.type },
        { headers: { "X-CSRF-Token": csrfToken } });
      onStarted(data);
      whenCallReturns(() => onReturned?.(data));
      if (action.href.startsWith("tel:")) window.location.href = action.href;
    } catch (e) { setError(errorMessage(e)); setBusy(false); }
  };
  return <div className="call-confirm" data-testid="call-confirm-form">
    <button type="button" className="sheet-back" onClick={onBack} data-testid="call-confirm-back">‹ Indietro</button>
    <h2 className="sheet-title" data-testid="call-confirm-title">Stai effettuando la chiamata ora?</h2>
    <strong data-testid="call-confirm-venue">{venue.name}</strong>
    <p data-testid="call-confirm-number">{action.display} · {action.source}</p>
    {error && <p role="alert" className="form-error" data-testid="call-confirm-error">{error}</p>}
    <button type="button" className="hud-button" disabled={busy} onClick={confirm}
      data-testid="call-confirm-yes"><Phone size={18} aria-hidden="true" /> {busy ? "Registro la chiamata…" : "Sì, chiama ora"}</button>
    <button type="button" className="hud-button hud-secondary" disabled={busy} onClick={onBack}
      data-testid="call-confirm-no">Non ora</button>
  </div>;
};